const SUBJECTS = [
  "Biology",
  "Chemistry",
  "Organic Chemistry",
  "Biochemistry",
  "Physics",
  "Calculus",
  "Statistics",
  "Anatomy",
  "Physiology",
  "Microbiology",
  "Genetics",
  "MMI Coaching",
  "Admissions Coaching",
  "Admissions Essays",
  "Study Skills",
];

export default function SubjectsMarquee() {
  const items = [...SUBJECTS, ...SUBJECTS];
  return (
    <section
      aria-label="Subjects offered"
      data-testid="subjects-marquee"
      className="bg-paper-100 border-y border-paper-200 py-5 overflow-hidden"
    >
      <div className="flex items-center w-max animate-marquee">
        {items.map((s, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-display font-bold text-2xl sm:text-3xl text-forest tracking-tight px-6">
              {s}
            </span>
            <span className="w-2 h-2 rounded-full bg-terracotta shrink-0" />
          </span>
        ))}
      </div>
    </section>
  );
}
